import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UploadService } from './upload.service';
import { CallCenterDatabaseTableData } from '../interfaces/call-center-database.interface';
import { AssignmentResult } from '../interfaces/call-center-service.interface';

@Injectable({
  providedIn: 'root'
})
export class CallCenterAssignmentService {

  constructor(
    private uploadService: UploadService,
    private snackBar: MatSnackBar
  ) {}

  /**
   * Assigns selected companies to an employee
   */
  assignCompanies(assignee: any, companyIds: number[]): Observable<AssignmentResult> {
    const requestData = {
      employee_id: Number(assignee.id),
      company_ids: companyIds.map(id => Number(id))
    };
    
    return this.uploadService.assignCompaniesToEmployee(requestData).pipe(
      map((response: AssignmentResult) => {
        if (response.success) {
          this.snackBar.open(
            `${response.assigned_count} cég sikeresen hozzárendelve ${assignee.username || assignee.fullname} munkatárshoz`, 
            'Bezárás', 
            {
              duration: 5000,
              panelClass: ['success-snackbar']
            }
          );
          
          // Ha voltak már létező hozzárendelések, tájékoztassuk a felhasználót
          if (response.skipped_count && response.skipped_count > 0) {
            setTimeout(() => {
              this.snackBar.open(
                `${response.skipped_count} cég már korábban hozzá volt rendelve ehhez a munkatárshoz`, 
                'Bezárás', 
                {
                  duration: 3000,
                  panelClass: ['warning-snackbar']
                }
              );
            }, 1000);
          }
        }
        return response;
      })
    );
  }

  /**
   * Removes assignments for selected companies
   */
  removeAssignments(companyIds: number[]): Observable<AssignmentResult> {
    if (companyIds.length === 0) {
      this.snackBar.open('Nincs kijelölt cég a hozzárendelés törléséhez', 'Bezárás', {
        duration: 3000,
        panelClass: ['warning-snackbar']
      });
      throw new Error('No companies selected');
    }

    const formattedIds = companyIds.map(id => Number(id));
    
    return this.uploadService.removeCompanyAssignments(formattedIds).pipe(
      map((response: AssignmentResult) => {
        if (response.success) {
          this.snackBar.open(
            `${response.removed_count} cég hozzárendelése sikeresen törölve${response.not_assigned_count && response.not_assigned_count > 0 ? `, ${response.not_assigned_count} céghez nem volt hozzárendelés` : ''}`, 
            'Bezárás', 
            {
              duration: 5000,
              panelClass: ['success-snackbar']
            }
          );
        }
        
        return response;
      })
    );
  }

  /**
   * Refreshes assignment data from backend
   */
  refreshAssignmentData(): Observable<CallCenterDatabaseTableData[]> {
    return this.uploadService.getDatabaseData().pipe(
      map((response: any) => {
        if (response.success && response.data) {
          // Konvertáljuk a dátum stringeket Date objektumokká és biztosítjuk az emails tömb meglétét
          return response.data.map((item: any) => ({
            ...item,
            date: item.date ? new Date(item.date) : undefined,
            emails: item.emails || [],
            emailValidStatuses: item.emailValidStatuses || {}
          }));
        }
        
        throw new Error('Failed to refresh assignment data');
      })
    );
  }
}